<div class="flex flex-row bg-secondary-400 -mx-6 -mt-6 justify-center text-white">
    <div class="text-3xl p-2 font-bold">Add New Note</div>
    <button matDialogClose class="appDialogClose p-2 absolute top-2 right-2" (click)="onClose()">
        <mat-icon class="text-current icon-size-5" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
</div>
<div class="noteDialog h-full">
    <form name="noteForm" [formGroup]="noteForm" class="flex flex-col form-full-width" autocomplete="off"
        ngxsForm="notes.noteForm">
        <mat-dialog-content class="pb-2">
            <div class="flex flex-row">
                <mat-form-field appearance="outline" class="flex-1">
                    <mat-label>Comment</mat-label>
                    <textarea type="textarea" matInput formControlName="comment" rows="3"></textarea>
                </mat-form-field>
            </div>
            <div class="flex flex-row h-18 pt-5">
                <mat-form-field appearance="outline" class="flex-1">
                    <mat-label>Document Type</mat-label>
                    <input type="text" matInput formControlName="documentType" />
                </mat-form-field>
            </div>
            <div class="flex flex-row h-18 pt-5">
                <mat-form-field appearance="outline" class="flex-1">
                    <mat-label>Document Ref</mat-label>
                    <input type="text" matInput formControlName="documentReference" />
                </mat-form-field>
            </div>

            <div class="flex flex-row h-18 pt-5">
                <mat-form-field appearance="outline" class="flex-1">
                    <mat-label>Tags</mat-label>
                    <input type="text" matInput formControlName="tags" [matAutocomplete]="tagsAuto"
                        [matChipInputFor]="tagsChipGrid" [matChipInputSeparatorKeyCodes]="[13, 188]"
                        (matChipInputTokenEnd)="addTag($event.value)" />
                    <mat-autocomplete #tagsAuto="matAutocomplete" (optionSelected)="addTag($event.option.value)">
                        @for (tag of filteredTags$ | async; track tag) {
                        <mat-option [value]="tag">{{tag}}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div class="flex flex-row pt-5 pb-5 min-h-20">
                <mat-chip-grid #tagsChipGrid>
                    @for (tag of selectedTags; track tag) {
                    <mat-chip [selectable]="true" [removable]="true" (removed)="removeTag(tag)">
                        {{ tag }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    }
                </mat-chip-grid>
            </div>
            <div class="flex flex-row h-18">
                <mat-form-field appearance="outline" class="flex-1">
                    <mat-label>Mentioned Users</mat-label>
                    <input type="text" matInput formControlName="mentions" [matAutocomplete]="usersAuto"
                        [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="[13, 188]"
                        (matChipInputTokenEnd)="addUser($event.value)" />
                    <mat-autocomplete #usersAuto="matAutocomplete" (optionSelected)="addUser($event.option.value)">
                        @for (user of filteredUsers$ | async; track user) {
                        <mat-option [value]="user">{{user.firstName}}
                            {{user.surname}}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div class="flex flex-row h-18">
                <mat-chip-grid #chipGrid>
                    @for (user of selectedUsers; track user) {
                    <mat-chip [selectable]="true" [removable]="true" (removed)="removeUser(user)">
                        {{ user.firstName }} {{ user.surname }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    }
                </mat-chip-grid>
            </div>

        </mat-dialog-content>
        <mat-dialog-actions class="flex flex-row justify-between">
            <button mat-raised-button matDialogClose type="button" class="bg-secondary-400 text-white">
                <fa-icon [icon]="['fasdl', 'window-close']" class="pr-2" size="lg"></fa-icon>Close
            </button>
            @if(data.editNote) {
            <button mat-raised-button (click)="onSubmit()" class="bg-secondary-400 text-white disabled:opacity-50"
                [disabled]="noteForm.invalid">
                <fa-icon [icon]="['fasdl', 'save']" class="pr-2" size="lg"></fa-icon>Update
            </button>
            }@else {
            <button mat-raised-button (click)="onSubmit()" class="bg-secondary-400 text-white disabled:opacity-50"
                [disabled]="noteForm.invalid">
                <fa-icon [icon]="['fasdl', 'save']" class="pr-2" size="lg"></fa-icon>Save
            </button>
            }

        </mat-dialog-actions>
    </form>
</div>